/* Svensk katalog for locale-customers-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('sv', {
  'sup.archiveBody': 'Vill du flytta {name} till arkivet? Leverantören döljs från aktiva leverantörslistor, men fakturor, betalningar och historik behålls. Du kan öppna leverantören igen senare.',
  'cust.title': 'Kunder',
  'cust.subtitle': 'Alla dina kunder på ett ställe',
  'cust.searchPh': 'Sök på kund eller belopp',
  'cust.titleHelp': 'Ditt kundregister — alla kunder med kontaktuppgifter, utestående och total försäljning. Tryck på en kund för att se uppföljning och fakturor.',
  'cust.searchHelp': 'Sök bland kunderna på namn, e-post, total försäljning eller utestående belopp.',
  'cust.uploadHelp': 'Importera kunder från en fil.',
  'cust.downloadHelp': 'Ladda ner kundlistan som CSV eller Excel.',
  'cust.addHelp': 'Lägg till en ny kund med kontaktuppgifter och uppföljningsstatus.',
  'cust.filterHelp': 'Filtrera kunderna på status (aktiv, prospekt, offert skickad, pausad), om de har utestående och om arkiverade ska visas.',
  'cust.listHelpTitle': 'Kundlistan',
  'cust.listHelp': 'Varje rad är en kund med kundnr, org.nr, e-post, telefon, utestående och total försäljning. Tryck på en rad för att öppna kunden.',
  'cust.filterOther': 'Annat',
  'cust.filterWithOutstanding': 'Endast med utestående',
  'cust.filterShowArchive': 'Visa arkiv',
  'cust.archived': 'Arkiverad',
  'cust.followUpInline': 'Uppföljning {date}',
  'cust.col.customer': 'Kund',
  'cust.col.number': 'Kundnr',
  'cust.col.org': 'Org.nr',
  'cust.col.email': 'E-post',
  'cust.col.phone': 'Telefon',
  'cust.col.outstanding': 'Utestående',
  'cust.col.totalSales': 'Total försäljning',
  'cust.outstandingInline': 'Utestående {amount}',
  'cust.balance.customerOwes': 'Kunden är skyldig dig {amount}',
  'cust.balance.youOwe': 'Du är skyldig kunden {amount}',
  'cust.balance.settled': 'Avräknad',
  'cust.followUp': 'Uppföljning',
  'cust.followUpHelp': 'Status, nästa uppföljningsdatum, anteckningar och senaste aktiviteter för kunden. Använd chattknappen för att logga dialog och skapa offerter.',
  'cust.dialogTitle': 'Kunddialog',
  'cust.dialogHelp': 'Öppna en konversation med kunden — logga meddelanden och bygg ett offertunderlag som du kan göra om till en offert.',
  'cust.openChat': 'Öppna chatt',
  'cust.startChat': 'Starta chatt',
  'cust.nextFollowUp': 'Nästa uppföljning',
  'cust.noFollowUpDate': 'Inget datum angivet',
  'cust.status': 'Status',
  'cust.salesTitle': 'Försäljning till kunden',
  'cust.salesHelp': 'Alla fakturor och kreditfakturor för kunden. Filtrera på alla, obetalda eller betalda — och öppna en faktura direkt med ”Öppna”.',
  'cust.salesAll': 'Alla',
  'cust.salesUnpaid': 'Inte betald',
  'cust.salesPaid': 'Betald',
  'cust.salesTotal': 'Totalt',
  'cust.noSalesMatch': 'Ingen försäljning matchade filtret.',
  'cust.creditNote': 'Kreditfaktura',
  'cust.invoice': 'Faktura',
  'cust.dueOn': 'Förfaller {date}',
  'cust.open': 'Öppna',
  'cust.pageRange': '{from}-{to} av {total}',
  'cust.prev': 'Föregående',
  'cust.next': 'Nästa',
  'cust.act.newInvoice': 'Ny faktura',
  'cust.act.newInvoiceHelp': 'Starta en ny faktura med den här kunden redan vald.',
  'cust.act.edit': 'Redigera',
  'cust.act.editHelp': 'Ändra kundens kontaktuppgifter, status och uppföljning.',
  'cust.act.merge': 'Slå ihop',
  'cust.act.mergeHelp': 'Slå ihop två kunder som är registrerade dubbelt — försäljning och utestående slås ihop på en kund.',
  'cust.act.archive': 'Flytta till arkiv',
  'cust.act.archiveHelp': 'Dölj kunden från aktiva listor. Fakturor, betalningar och historik behålls.',
  'cust.act.menu': 'Åtgärd',
  'cust.archiveTitle': 'Flytta till arkiv?',
  'cust.archiveBody': 'Vill du flytta {name} till arkivet? Kunden döljs från aktiva kundlistor, men fakturor, betalningar och historik behålls.',
  'cust.archiveStillUsed': 'Kunden används fortfarande på andra ställen',
  'cust.archiveGroup': '{n} kundgrupp',
  'cust.archiveGroups': '{n} kundgrupper',
  'cust.archiveSubscription': '{n} abonnemang',
  'cust.archiveSubscriptions': '{n} abonnemang',
  'cust.archiveAnd': ' och ',
  'cust.merge.title': 'Slå ihop kunder',
  'cust.merge.keep': 'Behålls',
  'cust.merge.remove': 'Slås ihop och tas bort',
  'cust.merge.swap': 'Byt vilken kund som behålls',
  'cust.merge.after': 'Efter sammanslagning',
  'cust.merge.name': 'Kundnamn',
  'cust.merge.totalSales': 'Total försäljning',
  'cust.merge.notConnected': 'Sammanslagning är inte kopplad till backend ännu.',
  'cust.merge.done': 'Kunderna har slagits ihop',
  'cust.merge.failed': 'Det gick inte att slå ihop kunderna.',
  'cust.form.name': 'Kundnamn',
  'cust.form.namePh': 'T.ex. Exempel AS',
  'cust.form.orgOptional': 'Org.nummer (valfritt)',
  'cust.form.org': 'Org.nummer',
  'cust.form.address': 'Adress',
  'cust.form.addressPh': 'Gatuadress',
  'cust.form.zip': 'Postnr',
  'cust.form.city': 'Ort',
  'cust.form.cityPh': 'Ort',
  'cust.form.crm': 'Kundstatus',
  'cust.form.nextLabel': 'Nästa: {date}',
  'cust.form.noFollowUp': 'Ingen uppföljning',
  'cust.form.dupTitle': 'Detta finns redan på en annan kund',
  'cust.form.dupName': '{names} har samma namn.',
  'cust.form.dupOrg': '{names} har samma organisationsnummer.',
  'cust.form.dupEmail': '{names} har samma e-postadress.',
  'cust.form.dupPhone': '{names} har samma telefonnummer.',
  'cust.form.dupUnnamed': 'En kund utan namn',
  'cust.form.dupBody': 'Kunden sparas som vanligt. Om det är samma kund kan du slå ihop de två från kundkortet i listan.',
  'cust.form.contacts': 'Kontaktpersoner',
  'cust.form.contactsSub': 'Kan väljas som mottagare när du skickar faktura, offert eller kvitto.',
  'cust.form.addContact': 'Lägg till kontaktperson',
  'cust.form.editContact': 'Redigera kontaktperson',
  'cust.form.contactFallback': 'Kontaktperson {n}',
  'cust.form.removeContact': 'Ta bort kontaktperson',
  'cust.form.contactTitle': 'Kontaktperson',
  'cust.form.newTitle': 'Ny kund',
  'cust.form.editTitle': 'Redigera kund',
  'cust.form.saveContact': 'Spara',
  'cust.form.contactName': 'Namn',
  'cust.form.contactNamePh': 'T.ex. Anna Andersson',
  'cust.form.contactRole': 'Roll',
  'cust.form.contactRolePh': 'T.ex. Ekonomi',
  'cust.form.defaultRef': 'Fast fakturareferens',
  'cust.form.defaultRefPh': 'T.ex. projektnummer, inköpsorder eller avdelning',
  'cust.form.creditLimit': 'Kreditgräns',
  'cust.form.creditLimitHint': 'Används i avstämningen för att mäta kundens öppna saldo mot företagets egen kreditpolicy. Ingen gräns spärrar fakturering.',
  'cust.form.creditLimitPh': 'T.ex. 60000',
  'cust.form.note': 'Kundanteckning',
  'cust.form.notePh': 'Anteckning om kunden',
  'cust.form.activity': 'Lägg till aktivitetsanteckning',
  'cust.form.activityPh': 'Ringde kunden, skickade prisuppdatering…',
  'cust.form.update': 'Uppdatera kund',
  'cust.form.save': 'Spara kund',
  'cust.crm.prospect': 'Prospekt',
  'cust.crm.quoteSent': 'Offert skickad',
  'cust.crm.active': 'Aktiv kund',
  'cust.crm.pause': 'Pausad',
  'cust.chat.scope.all': 'Hela konversationen',
  'cust.chat.scope.to': 'Till kund',
  'cust.chat.scope.from': 'Från kund',
  'cust.chat.scope.internal': 'Interna anteckningar',
  'cust.chat.helpAll': 'Du ser nu hela konversationen.',
  'cust.chat.helpTo': 'Du ser nu meddelanden som du har skickat.',
  'cust.chat.helpFrom': 'Du ser nu meddelanden från kunden.',
  'cust.chat.helpInternal': 'Det här är dina interna anteckningar i dialogen.',
  'cust.chat.threadsHelpTitle': 'Konversationer',
  'cust.chat.threadsHelp': 'Varje kund kan ha flera konversationer. Växla mellan dem här eller starta en ny dialog för ett nytt ärende.',
  'cust.chat.conversation': 'Konversation',
  'cust.chat.filterTitle': 'Filtrera konversationen',
  'cust.chat.filterHelp': 'Välj vad du vill se i fönstret nedan: hela konversationen, meddelanden du har skickat, meddelanden från kunden eller interna anteckningar.',
  'cust.chat.windowTitle': 'Konversationsfönster',
  'cust.chat.windowHelp': 'Meddelandena i dialogen. Det du skickar visas till höger, kundens meddelanden och interna anteckningar till vänster. Dra i nederkanten för att göra fönstret större.',
  'cust.chat.internal': 'Internt',
  'cust.chat.newInternalTitle': 'Ny intern anteckning',
  'cust.chat.saveInDialog': 'Spara i dialog',
  'cust.chat.saveMessage': 'Spara meddelande',
  'cust.chat.sendMessage': 'Skicka meddelande',
  'cust.chat.newTitle': 'Nytt meddelande',
  'cust.chat.newHelp': 'Skriv ett svar till kunden, klistra in ett meddelande du har fått eller anteckna något internt. Valt konversationsfilter styr om detta skickas till kunden, sparas som kundmeddelande eller sparas som intern anteckning.',
  'cust.chat.draftPh': 'Skriv svar, klistra in kundmeddelande eller anteckna vad ni kom överens om...',
  'cust.chat.newDialog': 'Ny dialog',
  'cust.chat.quoteTitle': 'Offertunderlag',
  'cust.chat.quoteHelp': 'Lägg till produkterna och priserna ni kom överens om i konversationen. Tryck på Skapa offert för att göra om det till ett offertutkast med kunden redan ifylld.',
  'cust.chat.findProduct': 'Hitta produkt/pris',
  'cust.chat.productPh': 'Sök produktnamn...',
  'cust.chat.dragToMessage': 'Dra till meddelandet',
  'cust.chat.dragTotal': 'Dra totalen till meddelandet',
  'cust.chat.dragBasis': 'Dra hela offertunderlaget till meddelandet',
  'cust.chat.quoteBasis': 'Hela underlaget',
  'cust.chat.remove': 'Ta bort',
  'cust.chat.total': 'Totalt',
  'cust.chat.makeQuote': 'Skapa offert',
  'cust.toast.updated': 'Kunden har uppdaterats',
  'cust.toast.saved': 'Kunden har sparats',
  'cust.toast.saveFailed': 'Kunde inte spara kunden.',
  'cust.toast.archived': 'Kunden har flyttats till arkivet',
  'cust.toast.archiveFailed': 'Kunde inte arkivera kunden.',
  'cust.toast.nothingToExport': 'Inga kunder att exportera',
  'cust.toast.exportFailed': 'Kunde inte exportera kundlistan.',
  'cust.toast.exported': 'Kundlistan har laddats ner',
  'cust.toast.noLedgerRows': 'Inga reskontrarader att exportera',
  'cust.toast.ledgerExportFailed': 'Kunde inte exportera kundreskontran.',
  'cust.toast.ledgerExported': 'Kundreskontran har laddats ner',
  'cust.toast.wrongFormat': 'Använd CSV eller XLSX med Plummes kundmall.',
  'cust.toast.noneInFile': 'Hittade inga kunder i filen.',
  'cust.toast.imported': '{n} kunder importerade',
  'cust.toast.importFailed': 'Kunde inte importera kunder.',
  'cust.error.xlsxImport': 'XLSX-import är inte tillgänglig än.',
  'cust.error.xlsxExport': 'Excel-export är inte tillgänglig än.',
  'cust.export.number': 'Kundnr',
  'cust.export.name': 'Namn',
  'cust.export.org': 'Orgnr',
  'cust.export.email': 'E-post',
  'cust.export.phone': 'Telefon',
  'cust.export.address': 'Adress',
  'cust.export.zip': 'Postnr',
  'cust.export.city': 'Ort',
  'cust.export.status': 'Status',
  'cust.export.followUp': 'Nästa uppföljning',
  'cust.export.defaultRef': 'Fast fakturareferens',
  'cust.export.note': 'Anteckning',
  'cust.ledger.code': 'Kod',
  'cust.ledger.date': 'Datum',
  'cust.ledger.doc': 'Verifikationsnr/fakturanr',
  'cust.ledger.type': 'Typ',
  'cust.ledger.due': 'Förfaller',
  'cust.ledger.debit': 'Debet',
  'cust.ledger.credit': 'Kredit',
  'cust.ledger.balance': 'Saldo efter rad',
  'cust.ledger.paid': 'Betalt',
  'cust.ledger.remaining': 'Återstår',
  'cust.ledger.partial': 'Delbetald',
  'cust.ledger.unpaid': 'Ej betald',
  'cust.ledger.posted': 'Bokförd',
  'cust.ledger.refund': 'Återbetalning till kund',
  'cust.ledger.payment': 'Kundinbetalning',
  'cust.ledger.creditOverpayment': 'Kredit / överbetalning',
  'cust.ledger.empty': 'Inga reskontrarader än.',
  'cust.import': 'Importera',
  'cust.importFrom': 'Importera från',
  'cust.ledgerShort': 'Reskontra',
  'cust.ledger.sheet': 'Kundreskontra',
  'cust.sheet.customers': 'Kunder',
});
